import { forwardRef, InputHTMLAttributes } from "react";
import styles from "./InputText.module.css";

// Estende as propriedades nativas de um input HTML
export interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {}

const InputText = forwardRef<HTMLInputElement, InputTextProps>(
    ({ className, ...props }, ref) => {
        // Combina a classe do CSS Module com qualquer className passado via props
        const combinedClassName = `${styles.input} ${className || ""}`.trim();

        return (
            <input
                type="text"
                ref={ref}
                className={combinedClassName}
                {...props}
            />
        );
    },
);

// É uma boa prática definir o displayName quando se usa forwardRef
InputText.displayName = "InputText";

export default InputText;
